import React, { useState, useEffect } from 'react'
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Chip,
  AppBar,
  Toolbar,
  IconButton,
  Switch,
  FormControlLabel,
  Paper,
  Divider,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  CircularProgress
} from '@mui/material'
import SpaceTheme from '../components/SpaceTheme'
import {
  ArrowBack as ArrowBackIcon,
  QuestionAnswer as QuestionIcon,
  Person as PersonIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Schedule as ScheduleIcon,
  Image as ImageIcon,
  Send as SendIcon,
  Close as CloseIcon,
  Mic as MicIcon,
  Stop as StopIcon,
  PlayArrow as PlayIcon,
  Delete as DeleteIcon,
  VolumeUp as VolumeUpIcon
} from '@mui/icons-material'
import { useAuth } from '../hooks/useAuth'
import { db } from '../firebase/config'
import { collection, query, where, getDocs, doc as firestoreDoc, getDoc, updateDoc, setDoc, orderBy, onSnapshot } from 'firebase/firestore'
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'
import { storage } from '../firebase/config'
import toast from 'react-hot-toast'

const StudentQuestions = ({ userData, onBack }) => {
  const { user } = useAuth()
  const [questions, setQuestions] = useState([])
  const [loading, setLoading] = useState(true)
  const [availability, setAvailability] = useState(false)
  const [selectedQuestion, setSelectedQuestion] = useState(null)
  const [responseDialogOpen, setResponseDialogOpen] = useState(false)
  const [responseText, setResponseText] = useState('')
  const [submitting, setSubmitting] = useState(false)
  
  // Sesli yanıt için state'ler
  const [isRecording, setIsRecording] = useState(false)
  const [hasRecordedAudio, setHasRecordedAudio] = useState(false)
  const [audioBlob, setAudioBlob] = useState(null)
  const [audioUrl, setAudioUrl] = useState(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const [mediaRecorder, setMediaRecorder] = useState(null)
  const [audioElement, setAudioElement] = useState(null)
  
  // Öğrenci adları için cache
  const [studentNamesCache, setStudentNamesCache] = useState({})

  useEffect(() => {
    console.log('🔄 useEffect tetiklendi')
    console.log('👤 Kullanıcı durumu:', user)
    console.log('👤 Kullanıcı ID:', user?.uid)
    console.log('👤 Kullanıcı email:', user?.email)
    
    if (user) {
      console.log('✅ Kullanıcı bulundu, veriler yükleniyor...')
      // Cache'i temizle
      setStudentNamesCache({})
      loadAvailabilityStatus()
      loadStudentQuestions()
    } else {
      console.log('❌ Kullanıcı bulunamadı')
    }
  }, [user])

  const loadAvailabilityStatus = async () => {
    try {
             // Android uygulamasıyla aynı koleksiyonu kullan: teacherAvailability
       const availabilityDoc = await getDoc(firestoreDoc(db, 'teacherAvailability', user.uid))
      if (availabilityDoc.exists()) {
        const data = availabilityDoc.data()
        setAvailability(data.isAvailable || false)
      } else {
                 // Müsaitlik dokümanı yoksa oluştur (varsayılan olarak kapalı)
         await setDoc(firestoreDoc(db, 'teacherAvailability', user.uid), {
          isAvailable: false,
          teacherId: user.uid,
          lastUpdated: new Date()
        })
        setAvailability(false)
      }
    } catch (error) {
      console.error('Error loading availability status:', error)
      toast.error('Müsaitlik durumu yüklenirken hata oluştu')
    }
  }

  const loadStudentQuestions = async () => {
    if (!user) {
      console.log('❌ Kullanıcı bulunamadı')
      return
    }

    try {
      setLoading(true)
      console.log('🔍 Öğrenci soruları yükleniyor...')
      console.log('👨‍🏫 Öğretmen ID:', user.uid)
      
      // Query questions for this teacher
      const questionsQuery = query(
        collection(db, 'studentQuestions'),
        where('teacherId', '==', user.uid)
        // orderBy('sentDate', 'desc') // Index hatası nedeniyle geçici olarak kaldırıldı
      )

      console.log('📝 Sorgu oluşturuldu:', questionsQuery)

      const unsubscribe = onSnapshot(questionsQuery, async (snapshot) => {
        console.log('📊 Sorgu sonucu:', snapshot.size, 'soru bulundu')
        
        // Tüm soruları debug için göster
        snapshot.docs.forEach((doc, index) => {
          console.log(`📄 Soru ${index + 1}:`, doc.data())
        })
        
        const questionsData = []
        
        for (const doc of snapshot.docs) {
          const data = doc.data()
          console.log('🔍 İşlenen soru verisi:', data)
          
                     // Get student name from cache or load it
           let studentName = studentNamesCache[data.studentId]
           
           if (!studentName) {
             try {
               console.log('🔍 Öğrenci ID:', data.studentId)
               const studentDoc = await getDoc(firestoreDoc(db, 'users', data.studentId))
               if (studentDoc.exists()) {
                 const studentData = studentDoc.data()
                 console.log('📝 Öğrenci verisi:', studentData)
                 
                 // Tüm olası alanları kontrol et
                 if (studentData.username && studentData.username.trim() !== '') {
                   studentName = studentData.username
                   console.log('👤 Username bulundu:', studentName)
                 } else if (studentData.displayName && studentData.displayName.trim() !== '') {
                   studentName = studentData.displayName
                   console.log('👤 DisplayName bulundu:', studentName)
                 } else if (studentData.name && studentData.name.trim() !== '') {
                   studentName = studentData.name
                   console.log('👤 Name bulundu:', studentName)
                 } else if (studentData.email && studentData.email.trim() !== '') {
                   studentName = studentData.email.split('@')[0]
                   console.log('👤 Email\'den ad bulundu:', studentName)
                 } else {
                   console.log('❌ Hiçbir ad alanı bulunamadı')
                   studentName = 'İsimsiz Öğrenci'
                 }
                 
                 console.log('👤 Final öğrenci adı:', studentName)
                 
                 // Cache'e kaydet
                 setStudentNamesCache(prev => ({
                   ...prev,
                   [data.studentId]: studentName
                 }))
               } else {
                 console.log('❌ Öğrenci dokümanı bulunamadı:', data.studentId)
                 studentName = 'Silinmiş Öğrenci'
                 
                 // Cache'e kaydet
                 setStudentNamesCache(prev => ({
                   ...prev,
                   [data.studentId]: studentName
                 }))
               }
             } catch (error) {
               console.error('❌ Öğrenci adı yüklenirken hata:', error)
               studentName = 'Hata: Öğrenci Adı Yüklenemedi'
               
               // Cache'e kaydet
               setStudentNamesCache(prev => ({
                 ...prev,
                 [data.studentId]: studentName
               }))
             }
           } else {
             console.log('👤 Cache\'den öğrenci adı alındı:', studentName)
           }

          questionsData.push({
            id: doc.id,
            studentId: data.studentId,
            studentName: studentName,
            description: data.description,
            imageUrl: data.imageUrl,
            status: data.status || 'pending',
            teacherResponse: data.teacherResponse,
            sentDate: data.sentDate,
            responseDate: data.responseDate
          })
        }

        // Client-side sorting (geçici çözüm)
        questionsData.sort((a, b) => {
          const dateA = a.sentDate?.toDate ? a.sentDate.toDate() : new Date(a.sentDate)
          const dateB = b.sentDate?.toDate ? b.sentDate.toDate() : new Date(b.sentDate)
          return dateB - dateA // En yeni önce
        })
        
        console.log('📋 Sıralanmış sorular:', questionsData)
        setQuestions(questionsData)
        setLoading(false)
      }, (error) => {
        console.error('❌ Sorgu hatası:', error)
        setLoading(false)
      })

      return unsubscribe
    } catch (error) {
      console.error('❌ Genel hata:', error)
      setLoading(false)
    }
  }

  const handleAvailabilityChange = async (event) => {
    const isAvailable = event.target.checked
    setAvailability(isAvailable)
    
    try {
             // Android uygulamasıyla aynı koleksiyonu kullan: teacherAvailability
       await setDoc(firestoreDoc(db, 'teacherAvailability', user.uid), {
        isAvailable: isAvailable,
        teacherId: user.uid,
        lastUpdated: new Date()
      })
      
      toast.success(isAvailable ? 'Soru almaya hazırsınız!' : 'Soru alma durduruldu')
    } catch (error) {
      console.error('Error updating availability:', error)
      toast.error('Durum güncellenirken hata oluştu')
      setAvailability(!isAvailable) // Revert on error
    }
  }

  const handleQuestionClick = (question) => {
    setSelectedQuestion(question)
    setResponseDialogOpen(true)
    
    // Eğer soru zaten cevaplandıysa ve sesli yanıt varsa, onu yükle
    if (question.status === 'answered' && question.teacherVoiceResponse) {
      setAudioUrl(question.teacherVoiceResponse)
      setHasRecordedAudio(true)
    }
  }

  const handleSubmitResponse = async () => {
    if (!selectedQuestion || (!responseText.trim() && !hasRecordedAudio)) {
      toast.error('Lütfen bir yanıt yazın veya sesli yanıt kaydedin')
      return
    }

    setSubmitting(true)
    try {
      if (hasRecordedAudio && audioBlob) {
        // Sesli yanıt varsa önce yükle
        await uploadVoiceResponse(responseText.trim())
      } else {
        // Sadece yazılı yanıt
        await sendTextResponse(responseText.trim())
      }
    } catch (error) {
      console.error('Error submitting response:', error)
      toast.error('Yanıt gönderilirken hata oluştu')
    } finally {
      setSubmitting(false)
    }
  }

  const uploadVoiceResponse = async (textResponse) => {
    try {
      const fileName = `voice_responses/${selectedQuestion.id}/${Date.now()}_${Math.random().toString(36).substring(7)}.mp3`
      const storageRef = ref(storage, fileName)
      
      await uploadBytes(storageRef, audioBlob)
      const downloadURL = await getDownloadURL(storageRef)
      
      await sendResponseWithVoice(textResponse, downloadURL)
    } catch (error) {
      console.error('Error uploading voice response:', error)
      toast.error('Ses dosyası yüklenirken hata oluştu')
      throw error
    }
  }

  const sendResponseWithVoice = async (textResponse, voiceURL) => {
         try {
       await updateDoc(firestoreDoc(db, 'studentQuestions', selectedQuestion.id), {
         status: 'answered',
         teacherResponse: textResponse,
         teacherVoiceResponse: voiceURL,
         responseDate: new Date()
       })

      toast.success('Yanıt ve sesli yanıt gönderildi!')
      resetResponseDialog()
    } catch (error) {
      console.error('Error sending response with voice:', error)
      toast.error('Yanıt gönderilirken hata oluştu')
      throw error
    }
  }

  const sendTextResponse = async (textResponse) => {
         try {
       await updateDoc(firestoreDoc(db, 'studentQuestions', selectedQuestion.id), {
         status: 'answered',
         teacherResponse: textResponse,
         responseDate: new Date()
       })

      toast.success('Yanıt gönderildi!')
      resetResponseDialog()
    } catch (error) {
      console.error('Error sending text response:', error)
      toast.error('Yanıt gönderilirken hata oluştu')
      throw error
    }
  }

  const resetResponseDialog = () => {
    setResponseDialogOpen(false)
    setResponseText('')
    setSelectedQuestion(null)
    setAudioBlob(null)
    setAudioUrl(null)
    setHasRecordedAudio(false)
    setIsRecording(false)
    setIsPlaying(false)
    if (audioElement) {
      audioElement.pause()
      setAudioElement(null)
    }
  }

  // Sesli yanıt fonksiyonları
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      const recorder = new MediaRecorder(stream, {
        mimeType: 'audio/webm;codecs=opus'
      })
      
      const chunks = []
      recorder.ondataavailable = (event) => {
        chunks.push(event.data)
      }
      
      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: 'audio/webm' })
        setAudioBlob(blob)
        setAudioUrl(URL.createObjectURL(blob))
        setHasRecordedAudio(true)
        setIsRecording(false)
        
        // Stream'i kapat
        stream.getTracks().forEach(track => track.stop())
      }
      
      recorder.start()
      setMediaRecorder(recorder)
      setIsRecording(true)
      toast.success('Kayıt başladı!')
      
    } catch (error) {
      console.error('Error starting recording:', error)
      toast.error('Mikrofon erişimi reddedildi veya kayıt başlatılamadı')
    }
  }

  const stopRecording = () => {
    if (mediaRecorder && isRecording) {
      mediaRecorder.stop()
      toast.success('Kayıt durduruldu!')
    }
  }

  const toggleRecording = () => {
    if (isRecording) {
      stopRecording()
    } else {
      if (hasRecordedAudio) {
        if (window.confirm('Zaten bir sesli yanıt kaydınız var. Yeni kayıt yapmak istiyor musunuz?')) {
          deleteRecording()
          startRecording()
        }
      } else {
        startRecording()
      }
    }
  }

  const playRecording = () => {
    if (audioUrl) {
      const audio = new Audio(audioUrl)
      audio.onended = () => setIsPlaying(false)
      audio.play()
      setIsPlaying(true)
      setAudioElement(audio)
      toast.success('Sesli yanıt çalınıyor...')
    }
  }

  const deleteRecording = () => {
    if (window.confirm('Sesli yanıt kaydını silmek istediğinizden emin misiniz?')) {
      setAudioBlob(null)
      setAudioUrl(null)
      setHasRecordedAudio(false)
      setIsPlaying(false)
      if (audioElement) {
        audioElement.pause()
        setAudioElement(null)
      }
      toast.success('Sesli yanıt silindi')
    }
  }

  const handleDeclineQuestion = async () => {
    if (!selectedQuestion) return

    setSubmitting(true)
         try {
       await updateDoc(firestoreDoc(db, 'studentQuestions', selectedQuestion.id), {
         status: 'declined',
         responseDate: new Date()
       })

      toast.success('Soru reddedildi')
      setResponseDialogOpen(false)
      setResponseText('')
      setSelectedQuestion(null)
    } catch (error) {
      console.error('Error declining question:', error)
      toast.error('Soru reddedilirken hata oluştu')
    } finally {
      setSubmitting(false)
    }
  }

  const getStatusChip = (status) => {
    switch (status) {
      case 'pending':
        return <Chip label="Bekliyor" color="warning" size="small" />
      case 'answered':
        return <Chip label="Cevaplandı" color="success" size="small" />
      case 'declined':
        return <Chip label="Reddedildi" color="error" size="small" />
      default:
        return <Chip label="Bilinmiyor" color="default" size="small" />
    }
  }

  const formatDate = (dateObj) => {
    if (!dateObj) return '-'
    
    let date
    if (dateObj instanceof Date) {
      date = dateObj
    } else if (dateObj.toDate) {
      date = dateObj.toDate()
    } else if (typeof dateObj === 'number') {
      date = new Date(dateObj)
    } else {
      return '-'
    }

    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  return (
    <SpaceTheme>
      <Box sx={{ flexGrow: 1 }}>
        {/* AppBar */}
        <AppBar position="static" elevation={0} sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
        }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onBack}
              sx={{ mr: 2 }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Öğrenci Soruları
            </Typography>
          </Toolbar>
        </AppBar>

      {/* Main Content */}
      <Container maxWidth="md" sx={{ py: 3 }}>
                 {/* Availability Status */}
         <Card sx={{ mb: 3 }}>
           <CardContent>
             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
               <Box>
                 <Typography variant="h6" fontWeight="bold" color="primary" gutterBottom>
                   Müsaitlik Durumu
                 </Typography>
                 <Typography variant="body2" color="text.secondary">
                   {availability ? '✅ Öğrenciler size soru gönderebilir' : '❌ Şu anda soru almıyorsunuz'}
                 </Typography>
                 <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                   {availability 
                     ? 'Öğrenciler sorularını size gönderebilir ve yanıt bekleyebilir.' 
                     : 'Öğrenciler size soru gönderemez. Soru almak için aktif edin.'
                   }
                 </Typography>
               </Box>
               <FormControlLabel
                 control={
                   <Switch
                     checked={availability}
                     onChange={handleAvailabilityChange}
                     color="primary"
                     size="medium"
                   />
                 }
                 label=""
               />
             </Box>
           </CardContent>
         </Card>

        {/* Questions List */}
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : questions.length === 0 ? (
          <Card>
            <CardContent sx={{ textAlign: 'center', py: 4 }}>
              <QuestionIcon sx={{ fontSize: 60, color: 'grey.400', mb: 2 }} />
              <Typography variant="h6" color="text.secondary" gutterBottom>
                Henüz soru yok
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Öğrencilerden gelen sorular burada görünecek
              </Typography>
            </CardContent>
          </Card>
        ) : (
          <List>
            {questions.map((question, index) => (
              <React.Fragment key={question.id}>
                <ListItem
                  button
                  onClick={() => handleQuestionClick(question)}
                  sx={{
                    borderRadius: 2,
                    mb: 1,
                    backgroundColor: '#fff',
                    boxShadow: 1,
                    '&:hover': {
                      backgroundColor: 'grey.50',
                      transform: 'translateX(4px)',
                      transition: 'all 0.2s ease-in-out'
                    }
                  }}
                >
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: 'primary.main' }}>
                      <PersonIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {question.studentName}
                        </Typography>
                        {getStatusChip(question.status)}
                      </Box>
                    }
                    secondary={
                      <Box>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                          {question.description}
                        </Typography>
                        {question.imageUrl && (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                            <ImageIcon sx={{ fontSize: 16, color: 'grey.500' }} />
                            <Typography variant="caption" color="text.secondary">
                              Resim eklendi
                            </Typography>
                          </Box>
                        )}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <ScheduleIcon sx={{ fontSize: 16, color: 'grey.500' }} />
                          <Typography variant="caption" color="text.secondary">
                            {formatDate(question.sentDate)}
                          </Typography>
                        </Box>
                                                 {question.teacherResponse && (
                           <Box sx={{ mt: 1, p: 1, bgcolor: 'success.50', borderRadius: 1 }}>
                             <Typography variant="caption" color="success.main" fontWeight="bold">
                               Cevabınız: {question.teacherResponse}
                             </Typography>
                             {question.teacherVoiceResponse && (
                               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                                 <VolumeUpIcon sx={{ fontSize: 16, color: 'success.main' }} />
                                 <Typography variant="caption" color="success.main">
                                   Sesli yanıt eklendi
                                 </Typography>
                               </Box>
                             )}
                           </Box>
                         )}
                      </Box>
                    }
                  />
                </ListItem>
                {index < questions.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        )}
      </Container>

      {/* Response Dialog */}
      <Dialog
        open={responseDialogOpen}
        onClose={() => setResponseDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <PersonIcon color="primary" />
            <Typography variant="h6">
              {selectedQuestion?.studentName} - Soru Yanıtla
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Öğrenci Sorusu:
            </Typography>
            <Paper sx={{ p: 2, bgcolor: 'grey.50' }}>
              <Typography variant="body1">
                {selectedQuestion?.description}
              </Typography>
              {selectedQuestion?.imageUrl && (
                <Box sx={{ mt: 2 }}>
                  <img 
                    src={selectedQuestion.imageUrl} 
                    alt="Soru resmi" 
                    style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 8 }}
                  />
                </Box>
              )}
            </Paper>
          </Box>
          
                     <TextField
             fullWidth
             multiline
             rows={4}
             label="Yanıtınız"
             value={responseText}
             onChange={(e) => setResponseText(e.target.value)}
             placeholder="Öğrencinin sorusuna yanıtınızı yazın..."
             variant="outlined"
             sx={{ mb: 2 }}
           />

           {/* Sesli Yanıt Bölümü */}
           <Box sx={{ mb: 2 }}>
             <Typography variant="subtitle2" color="primary" fontWeight="bold" gutterBottom>
               Sesli Yanıt
             </Typography>
             
             <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
               <Button
                 variant={isRecording ? "contained" : "outlined"}
                 color={isRecording ? "error" : "primary"}
                 onClick={toggleRecording}
                 disabled={submitting}
                 startIcon={isRecording ? <StopIcon /> : <MicIcon />}
                 sx={{ flex: 1 }}
               >
                 {isRecording ? 'Kayıt Durdur' : 'Kayıt Başlat'}
               </Button>
               
               {hasRecordedAudio && (
                 <>
                   <Button
                     variant="outlined"
                     color="secondary"
                     onClick={playRecording}
                     disabled={submitting || isPlaying}
                     startIcon={isPlaying ? <StopIcon /> : <PlayIcon />}
                   >
                     {isPlaying ? 'Durdur' : 'Dinle'}
                   </Button>
                   
                   <Button
                     variant="outlined"
                     color="error"
                     onClick={deleteRecording}
                     disabled={submitting}
                     startIcon={<DeleteIcon />}
                   >
                     Sil
                   </Button>
                 </>
               )}
             </Box>
             
             {isRecording && (
               <Alert severity="info" sx={{ mt: 1 }}>
                 Kayıt yapılıyor... Mikrofonunuzu kullanın.
               </Alert>
             )}
             
             {hasRecordedAudio && !isRecording && (
               <Alert severity="success" sx={{ mt: 1 }}>
                 Sesli yanıt kaydedildi! Dinleyebilir veya yeni kayıt yapabilirsiniz.
               </Alert>
             )}
             
             {/* Mevcut sesli yanıt varsa göster */}
             {selectedQuestion?.teacherVoiceResponse && selectedQuestion?.status === 'answered' && (
               <Box sx={{ mt: 2, p: 2, bgcolor: 'info.50', borderRadius: 1 }}>
                 <Typography variant="subtitle2" color="info.main" fontWeight="bold" gutterBottom>
                   Mevcut Sesli Yanıt
                 </Typography>
                 <Button
                   variant="outlined"
                   color="info"
                   onClick={playRecording}
                   disabled={submitting || isPlaying}
                   startIcon={isPlaying ? <StopIcon /> : <PlayIcon />}
                   size="small"
                 >
                   {isPlaying ? 'Durdur' : 'Sesli Yanıtı Dinle'}
                 </Button>
               </Box>
             )}
           </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDeclineQuestion}
            color="error"
            disabled={submitting}
            startIcon={<CancelIcon />}
          >
            Reddet
          </Button>
          <Button
            onClick={() => setResponseDialogOpen(false)}
            disabled={submitting}
          >
            İptal
          </Button>
          <Button
            onClick={handleSubmitResponse}
            variant="contained"
            disabled={!responseText.trim() || submitting}
            startIcon={<SendIcon />}
          >
            Yanıtla
          </Button>
        </DialogActions>
      </Dialog>
      </Box>
    </SpaceTheme>
  )
}

export default StudentQuestions
